// extracted by mini-css-extract-plugin
export default {"row":"K2Rj8jjZISRSfUhnr0A0","coachCell":"IpkUHqiywb2i6YtkwX_s"};